"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mdastToFlat = void 0;
const mdastToFlat = (mdast) => {
    const nodes = [];
    const contents = [];
    const definitions = {};
    const footnotes = {};
    const footnoteOrder = [];
    const doc = {
        nodes,
        contents,
        definitions,
        footnotes,
        footnoteOrder,
    };
    const traverse = (token, parent) => {
        const idx = nodes.length;
        const node = { ...token, idx, parent };
        nodes.push(node);
        if (token.children) {
            if (token.children instanceof Array) {
                node.children = token.children
                    .map((token) => traverse(token, idx))
                    .filter((i) => i > -1);
            }
            else {
                const childIndex = traverse(token.children, idx);
                if (childIndex > -1) {
                    node.children = [childIndex];
                }
            }
        }
        switch (node.type) {
            case 'heading':
                contents.push(idx);
                return idx;
            case 'definition':
                definitions[node.identifier] = idx;
                return -1;
            case 'footnoteDefinition':
                footnotes[node.identifier] = idx;
                return -1;
            default:
                return idx;
        }
    };
    if (mdast) {
        traverse(mdast, 0);
        // Process references.
        let footnoteCounter = 0;
        for (const node of nodes) {
            if (node.type === 'footnoteReference' || node.type === 'imageReference') {
                const identifier = node.identifier || node.value;
                if (identifier) {
                    const footnoteIndex = footnotes[identifier];
                    if (footnoteIndex !== undefined) {
                        const definition = nodes[footnoteIndex];
                        if (!definition.cnt) {
                            definition.cnt = ++footnoteCounter;
                            footnoteOrder.push(definition.idx);
                        }
                    }
                }
            }
        }
        // Process root node.
        const root = doc.nodes[0];
        root.depth = 0;
    }
    return doc;
};
exports.mdastToFlat = mdastToFlat;
